/**
 * When true, every URL on this origin (app.lazystudio.ai) shows StayTuned
 * instead of the product — no Clerk, no API, no app shell.
 *
 * Production: set REACT_APP_MAINTENANCE_MODE=true in the Lightsail deploy
 * workflow, then push to `deploy`.
 * Preview without taking the app down: open /stay-tuned while the flag is off.
 */
export const MAINTENANCE_MODE_ENABLED =
  (process.env.REACT_APP_MAINTENANCE_MODE ?? "false").trim().toLowerCase() ===
  "true";
